import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CookieBanner from './CookieBanner';
import DesktopNav from './navigation/DesktopNav';
import MobileBottomNav from './navigation/MobileBottomNav';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [isDashboardEnabled, setIsDashboardEnabled] = useState(false);

  useEffect(() => {
    const checkDashboardEnabled = () => {
      const saved = localStorage.getItem('dashboard-enabled');
      if (saved) {
        setIsDashboardEnabled(JSON.parse(saved));
      } else {
        setIsDashboardEnabled(false);
      }
    };

    checkDashboardEnabled();
    window.addEventListener('storage', checkDashboardEnabled);
    const interval = setInterval(checkDashboardEnabled, 500);

    return () => {
      window.removeEventListener('storage', checkDashboardEnabled);
      clearInterval(interval);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#0a0a0f' }}>
      {/* Desktop Navigation */}
      <DesktopNav />

      {/* Spacer for fixed desktop nav */}
      <Box sx={{ display: { xs: 'none', md: 'block' }, height: 64 }} />

      <Box component="main" sx={{ flexGrow: 1, pb: { xs: '80px', md: 0 } }}>
        {children}
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 5,
          bgcolor: '#0a0a0f',
          borderTop: '1px solid rgba(201,168,124,0.1)',
          mt: 'auto',
          mb: { xs: '64px', md: 0 },
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" align="center" sx={{ color: '#8a8a9a', mb: 2 }}>
            &copy; {new Date().getFullYear()} Ivy Astrology. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mb: 2, flexWrap: 'wrap' }}>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/terms')}
              sx={{
                color: '#8a8a9a',
                textDecoration: 'none',
                '&:hover': { color: '#c9a87c' },
              }}
            >
              Terms &amp; Conditions
            </Link>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/privacy')}
              sx={{
                color: '#8a8a9a',
                textDecoration: 'none',
                '&:hover': { color: '#c9a87c' },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/pricing')}
              sx={{
                color: '#8a8a9a',
                textDecoration: 'none',
                '&:hover': { color: '#c9a87c' },
              }}
            >
              Pricing
            </Link>
            <Link
              href="mailto:contact@ivyastrology.com"
              variant="body2"
              sx={{
                color: '#8a8a9a',
                textDecoration: 'none',
                '&:hover': { color: '#c9a87c' },
              }}
            >
              Contact Us
            </Link>
          </Box>
          <Typography variant="caption" align="center" display="block" sx={{ color: '#5a5a6a' }}>
            An Irish Astrology Business. For entertainment and personal growth purposes.
          </Typography>
        </Container>
      </Box>

      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />

      <CookieBanner />
    </Box>
  );
};

export default Layout;
